import angular from 'angular';
import {NOTIFICATION_TYPE_ERROR} from "@/vue/store/modules/notifications";

angular.module('vrm.core').controller('ProfileResetPasswordController', ProfileResetPasswordController);

/**
 * @constructor
 * @ngInject
 */
function ProfileResetPasswordController(
    $log,
    $scope,
    $state,
    UserService,
    vrmNotificationsService,
    locale,
) {
    $log.info('ProfileResetPasswordController');

    $scope.credentials = {
        current_password: null,
        password: null,
        password_confirm: null
    };

    $scope.userInfo = {
        name: '',
        email: ''
    }
    UserService.getUser().then(user => {
        $scope.userInfo = {
            name: user.name,
            email: user.email
        }
    });

    let passwordRequirementsNotificationId;

    $scope.savePasswordForm = function () {
        // Remove password requirements notification if it has been fixed
        if ($scope.updatePasswordForm.password.$valid) {
            vrmNotificationsService.remove(passwordRequirementsNotificationId);
        }

        if (!$scope.updatePasswordForm.password.$valid) {
            // Show the password requirements if password invalid
            passwordRequirementsNotificationId = vrmNotificationsService.add({
                type: NOTIFICATION_TYPE_ERROR,
                title: locale.getString('general.password_requirements'),
                message: `<ul>${locale.getString('general.password_consists')}` +
                    `<li>${locale.getString('general.password_requirement_minimum')}</li>` +
                    `<li>${locale.getString('general.password_requirement_alphanumeric')}</li>` +
                    `<li>${locale.getString('general.password_requirement_special_character')}</li>` +
                    `<li>${locale.getString('general.password_requirement_email')}</li>` +
                    `<li>${locale.getString('general.password_requirement_name')}</li></ul>`,
                lifespan: 0, // Don't expire, give user time to change their password
            });
            return;
        } else if (!$scope.updatePasswordForm.$valid) {
            return;
        }

        UserService.save($scope.credentials).then(function (success) {
            if (success) {
                $state.go('base.installation-overview');
            }
        })
    }

}
